module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x320-54d36d2e2e00f7b2d980d860774f345b.webp";